import { IonLoading } from '@ionic/react'

import { useLoyaltyRestrictions } from '../../../auth/account/utils'
import { LoyaltyRedemptionDetail } from '../../../loyalty/components/loyalty-redemption-detail'
import { useApplyClientRewards } from '../../../marketing/customer-opt-in/mutations'
import { usePairedLoyalty } from '../queries'

import type { ApplyLoyaltyReward } from '../../../loyalty/loyalty.schema'

function PairedLoyaltyDetail() {
  const loyaltyRestrictions = useLoyaltyRestrictions()

  const pairedLoyalty = usePairedLoyalty()

  const applyRewards = useApplyClientRewards()

  function handleApplyRewards(
    rewards: Array<ApplyLoyaltyReward>,
    options?: { redeemEarly: boolean }
  ) {
    applyRewards.mutate({ rewards, options })
  }

  return (
    <>
      {pairedLoyalty.loyalty ? (
        <LoyaltyRedemptionDetail
          data={pairedLoyalty.loyalty}
          checkInMethod={{
            email: pairedLoyalty.loyalty.checkedInEmail,
            phone: pairedLoyalty.loyalty.checkedInPhone,
          }}
          // disabled={loyalty.isLoading}
          onApplyRewards={handleApplyRewards}
          restrictions={loyaltyRestrictions}
        />
      ) : pairedLoyalty.status === 'error' ? (
        <div>
          <p>Error: </p>
          {pairedLoyalty.loyaltyError ? (
            <p>
              {pairedLoyalty.loyaltyError instanceof Error
                ? pairedLoyalty.loyaltyError.message
                : 'Unknown Error.'}
            </p>
          ) : null}
          {pairedLoyalty.stationClientError ? (
            <p>
              {pairedLoyalty.stationClientError instanceof Error
                ? pairedLoyalty.stationClientError.message
                : 'Unknown Error.'}
            </p>
          ) : null}
        </div>
      ) : (
        <IonLoading message="Loading Rewards..." isOpen />
      )}
    </>
  )
}

export { PairedLoyaltyDetail }
